import { render, staticRenderFns } from "./PatientEncounters.vue?vue&type=template&id=56efbfb9&"
import script from "./PatientEncounters.vue?vue&type=script&lang=js&"
export * from "./PatientEncounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports